
export type CheckSubscriptionStatusParams = {
/**
 * 상품 코드. 지정 시 현재 사용자 소유의 해당 상품 코드와 정확히 일치하는 구독만 조회하며, 미지정 시 기존 비 Paddle 구독을 조회합니다.
 */
productCode?: string;
};
